import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'


// export const ssoLogin = async (params: SSOLoginInfo) => request.post(`${HOSTS.BASE}/api/entweb/entAdmin/ossLogin`,  params)

// 发送验证码
export const sendVerificationCode = async (params: {userName: string}) => request.post(`${HOSTS.BASE}/api/entweb/entAdmin/sendVerificationCode`, params)

// 校验邮箱验证码
export const verifyCodeEmail = async (params: {
  // 登录用户名-邮箱
  userName?: string;
  // 验证码
  verificationCode?: string;
}) => request.post(`${HOSTS.BASE}/api/entweb/entAdmin/verification`, params)

// 重置密码
export const resetPassword = async (params:  {
  /** 用户名 */
  userName: string;
  /** 验证码 */
  verificationCode: string;
  /** 新密码 */
  password: string;
}) => request.post(`${HOSTS.BASE}/api/entweb/entAdmin/forgetPassword`, params)


// 修改密码请求
export const editPassword = async (params:  {
  // 登录用户名-邮箱
  userName: string;
  // 旧密码
  oldPwd: string;
  // 新密码
  newPwd: string;
}) => request.post(`${HOSTS.BASE}/api/entweb/entAdmin/changePassword`, params)

